import moment from "moment-timezone";
import React from "react";
import { notification, Tooltip, Icon, Button } from "antd";
import { Link } from "react-router-dom";
import { number } from "prop-types";
import striptags from "striptags";
import TurnDownService from "turndown";
const turndownService = new TurnDownService();

const CryptoJS = require("crypto-js");

import dompurify from "dompurify";
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

import TCUserAvatar from "../components/common/TCUserAvatar";
import { SystemApi } from "../services/generated-sdk";
import * as _ from "lodash";
import { getLocationForCurrentSession } from "./data-residency";

export function delay(timeout) {
  return new Promise((resolve) => setTimeout(resolve, timeout));
}

export function getLocalDate(date, format = "lll") {
  return moment.tz(date, window["TIMEZONE"] || timeZone).format(format);
}

export function trackGoal(goalId) {
  let shouldTrack = false;
  const ENABLE_ON_DEV = false; // switch this to test on local
  if (process.env.NODE_ENV == "production") {
    shouldTrack = true;
  }
  if (ENABLE_ON_DEV) {
    shouldTrack = true;
  }
  if (shouldTrack) {
    //window.fathom.trackGoal(goalId, 0);
  }
}

export function toggleIntercom(show = false) {
  try {
    if (window["Intercom"] != undefined) {
      window["Intercom"]("update", {
        hide_default_launcher: !show,
      });
      if (!show) window["Intercom"]("hide");
      // else Intercom("hide");
    }
  } catch (e) {
    console.log({ toggle_intercom_err: e });
  }
}

export function closeDialogue() {
  if (inIframe()) {
    window.parent.postMessage("CLOSE_DIALOGUE", "*");
  }
}

export async function getSystemStatus(params = {}, callback, from) {
  if (from) console.log(">>>> CALLING FROM >>" + from);
  const API = new SystemApi();
  try {
    const result = await API.getSystemStatus({ ...params });
    if (callback) callback(false, result);
    await delay(5000);
    getSystemStatus(params, callback, from);
  } catch (e) {
    console.error({ systemstatus_fetch_error: e });
    if (e.json) {
      e.json().then((data) => {
        console.error({ systemstatus_fetch_error_check: data });
        //handleError(data.statusCode, {}, data.message || "");
      });
    }
    if (e && e.status != undefined) {
      handleError(e.status);
    }
    console.log("Waiting for delay....", callback);
    if (callback) callback(e, false);
    await delay(5000000);
    getSystemStatus(params, callback, from);
  }
}

export function getBaseURL() {
  return process.env.BASE_URL || "http://0.0.0.0:8080";
}

export function getLocalRawDate(date, format = "lll") {
  return moment.tz(date, window["TIMEZONE"] || timeZone);
}

export function getLocalFromNow(date) {
  return moment.tz(date, window["TIMEZONE"] || timeZone).fromNow();
}

export function camelToSnake(string) {
  return string
    .replace(/[\w]([A-Z])/g, function (m) {
      return m[0] + "_" + m[1];
    })
    .toLowerCase();
}

export function removeTags(str) {
  if (str === null || str === "" || str === undefined) return false;
  else str = str.toString();
  return str.replace(/(<([^>]+)>)/gi, "");
}

const SAFE_HTML_TAGS = new Set([
  "a",
  "abbr",
  "b",
  "blockquote",
  "br",
  "code",
  "div",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "i",
  "img",
  "li",
  "ol",
  "p",
  "pre",
  "s",
  "span",
  "strong",
  "sub",
  "sup",
  "table",
  "tbody",
  "td",
  "th",
  "thead",
  "tr",
  "u",
  "ul",
]);

const HTML_TAG_REGEX = /<\s*\/?\s*([0-9a-z-]+)([^>]*)>/gi;

function escapeUnsupportedTags(html = "") {
  if (typeof html !== "string") {
    return html;
  }
  return html.replace(HTML_TAG_REGEX, (match, tagName) => {
    if (SAFE_HTML_TAGS.has(tagName.toLowerCase())) {
      return match;
    }
    return match.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  });
}

export function getNotificationHref(notification) {
  let href = "";
  switch (notification.systemName) {
    case "COMMENT_MENTION":
      href = `/project/${notification.project}/test_cases/${notification.entityId}`;
      break;
    case "EXEC_COMMENT_MENTION":
    case "EXEC_STEP_COMMENT_MENTION":
      href = `/project/${notification.project}/test_plans/${
        notification.entityId
      }/view?testPlanTestCase=${_.get(
        notification,
        "additionalDetails.test_plan_test_case",
        0
      )}`;
      break;
    case "TEST_PLAN_ASSIGNED":
      href = `/project/${notification.project}/test_plans/${notification.entityId}/run?assigned_to_me=1`;
      break;
    case "IMPORT_FINISHED":
      href = `/project/${notification.project}/manage`;
      break;
    case "TEST_PLAN_DELAYED":
    case "TEST_PLAN_APPROACHING":
    case "TEST_PLAN_FINISHED":
      href = `/project/${notification.project}/test_plans/${notification.entityId}/view`;
      break;
    case "TEST_PLAN_REOPENED":
      href = `/project/${notification.project}/test_plans/${notification.entityId}/run`;
      break;
    case "ADD_PROJECT_MEMBER":
      href = `/project/${notification.entityId}`;
      break;
    case "TEST_CASE_REJECTED":
      href = `/project/${notification.project}/manage`;
      break;
    case "TEST_CASE_APPROVED":
    case "SEND_FOR_REVIEW_CHANGES":
    case "SEND_FOR_APPROVAL":
      href = `/project/${notification.project}/test_cases/${notification.entityId}`;
      break;
    case "ISSUE_STATUS_CHANGED":
    case "ISSUE_CREATED":
    case "ISSUE_ASSIGNEE_CHANGED":
    // TCV-6567 follow-up (Hitesh): in-app notifications for issue comments
    // (mention, added, updated) also need to land on the parent issue page.
    case "ISSUE_COMMENT_MENTION":
    case "ISSUE_COMMENT_ADDED":
    case "ISSUE_COMMENT_UPDATED":
      href = `/project/${notification.project}/issues/${notification.entityId}`;
      break;
    case "GENERIC_NOTIFICATION":
      href =
        notification.testCaseUrl || `/project/${notification.project}/manage`;
      break;
    default:
      break;
  }
  return href;
}

export function getMentions() {
  const quillContainer = document.getElementsByClassName("ql-container")[0];
  const mentions = [];
  if (quillContainer) {
    const elems = quillContainer.getElementsByClassName("mention");
    for (let index = 0; index < elems.length; index++) {
      const element = elems[index];
      const denotationChar = element.getAttribute("data-denotation-char");
      if (denotationChar == "@") {
        const id = element.getAttribute("data-id");
        mentions.push(id);
      }
    }
  }
  return mentions;
}

export function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export function shouldCheckPlan(path) {
  // return allowed URLs for expired plans
  let shouldCheckPlan = true;
  ["upgrade_plan", "select_plan", "users", "show_current_plan", "invoices"].map(
    (route) => {
      if (path.includes(route)) shouldCheckPlan = false;
    }
  );
  return shouldCheckPlan;
}

export function getWarningMessage(
  state,
  data,
  enabledFeatures = [],
  company = null
) {
  switch (state) {
    case "trialPeriodOver":
      const today = moment();
      // moment().fromNow('')
      const expiration = _.get(data, "company.trialDetails.expiration");
      const safetyLimit = moment.unix(expiration);
      safetyLimit.add(8, "weeks");
      let message = "";
      if (safetyLimit.diff(today, "days") > 0) {
        const weeks = safetyLimit.diff(today, "weeks");
        const days = safetyLimit.diff(today, "days");
        message = `Don't worry, all your data is safely preserved in Test Collab for next ${
          weeks ? weeks + " weeks" : days + " days"
        }.`;
      }
      let msgPrefix = "Your plan is expired!";
      if (enabledFeatures && enabledFeatures.includes("disable_free_plan")) {
        if (
          company &&
          !company.stripeInfo &&
          (company.plan == "premium" || company.plan == "business") &&
          company.trialDetails &&
          !company.trialDetails.isActive
        ) {
          msgPrefix = "Your free trial is expired!";
        }
      }
      return (
        msgPrefix +
        " " +
        message +
        "You may continue using TestCollab's awesome test management features by purchasing a subscription below. Please feel free to reach out to us at support@testcollab.com for any clarification."
        // "You may continue using Test Collab's awesome test management features by purchasing a subscription below or you may downgrade to Free (3 users) plan to use our basic test management tool."
      );
    case "planExpired":
      return "Your plan has expired!";
    case "limitexhaused_users":
      return (
        <span>
          You have more users than plan's limit. Please delete some users to
          continue OR <Link to="/upgrade_plan">Upgrade Plan</Link>
        </span>
      );
    case "limitexhaused_projects":
      return (
        <span>
          You have more projects than plan's limit. Please delete some projects
          to continue OR <Link to="/upgrade_plan">Upgrade Plan</Link>
        </span>
      );
    case "limitexhaused_testCases":
      return (
        <span>
          You have more test cases than plan's limit. Please delete some test
          cases to continue OR <Link to="/upgrade_plan">Upgrade Plan</Link>
        </span>
      );
    case "limitexhaused_executedCases":
      return (
        <span>
          You have more executed test cases than plan's limit. Please delete
          some test plan to continue OR{" "}
          <Link to="/upgrade_plan">Upgrade Plan</Link>
        </span>
      );
    default:
      return "";
  }
}

export function validateURL(textval) {
  if (!textval) return true;
  // avoid query string in url validate
  if (textval.length > 100 && textval.indexOf("?") > 0) {
    textval = textval.split("?")[0];
  }
  var urlregex = new RegExp(
    "^(http|https|ftp)://([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&amp;%$-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0).(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9-]+.)*[a-zA-Z0-9-]+.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|app|[a-zA-Z]{2,63}))(:[0-9]+)*(/($|[a-zA-Z0-9.,?'\\+&amp;%$#=~_-]+))*$"
  );
  //console.log({ test: urlregex.test(textval), textval });
  return urlregex.test(textval);
}

// not working properly - TCV-6041
export function validateURL_new(input) {
  if (input == null || input === "") return true; // keep old behavior
  if (typeof input !== "string") return false;
  const s = input.trim();
  if (s.length > 2048) return false; // sane cap
  try {
    const u = new URL(s);
    if (!["http:", "https:", "ftp:"].includes(u.protocol)) return false;
    if (!u.hostname) return false;
    if (u.username || u.password) return false; // avoid user:pass URLs
    if (u.port && (+u.port < 1 || +u.port > 65535)) return false;
    // Optional: ignore very long queries without mutating input
    if (u.search && s.length > 100) {
      const base = `${u.origin}${u.pathname}`;
      try {
        new URL(base);
      } catch {
        return false;
      }
    }

    // Additional strict hostname validation without regex
    const host = u.hostname;

    function isDigit(ch) {
      const code = ch.charCodeAt(0);
      return code >= 48 && code <= 57; // 0-9
    }

    function isAlpha(ch) {
      const code = ch.charCodeAt(0);
      return (
        (code >= 65 && code <= 90) || // A-Z
        (code >= 97 && code <= 122) // a-z
      );
    }

    function isAlphaNum(ch) {
      return isAlpha(ch) || isDigit(ch);
    }

    function isHex(ch) {
      const code = ch.charCodeAt(0);
      return (
        (code >= 48 && code <= 57) || // 0-9
        (code >= 65 && code <= 70) || // A-F
        (code >= 97 && code <= 102) // a-f
      );
    }

    function isNumericOnly(str) {
      if (str.length === 0) return false;
      for (let i = 0; i < str.length; i++) {
        if (!isDigit(str[i])) return false;
      }
      return true;
    }

    function isValidIPv4(h) {
      const parts = h.split(".");
      if (parts.length !== 4) return false;
      for (let i = 0; i < parts.length; i++) {
        const p = parts[i];
        if (p.length === 0 || p.length > 3) return false;
        // disallow leading plus/minus or spaces
        let num = 0;
        for (let j = 0; j < p.length; j++) {
          const ch = p[j];
          if (!isDigit(ch)) return false;
          num = num * 10 + (ch.charCodeAt(0) - 48);
        }
        if (num < 0 || num > 255) return false;
        // avoid octets like 01, 001 unless the value is exactly 0
        if (p.length > 1 && p[0] === "0") return false;
      }
      return true;
    }

    function isValidIPv6(h) {
      // Basic IPv6 check: groups (up to 8), hex digits, optional :: compression
      if (h.indexOf(":") === -1) return false;
      // count occurrences of :: (compression)
      let compressionCount = 0;
      for (let i = 0; i < h.length - 1; i++) {
        if (h[i] === ":" && h[i + 1] === ":") compressionCount++;
      }
      if (compressionCount > 1) return false;

      const parts = h.split(":");
      if (parts.length > 8 && compressionCount === 0) return false;

      let groups = 0;
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        if (part.length === 0) {
          // allowed for compression (::) or edge (::1, 2001::)
          continue;
        }
        if (part.length < 1 || part.length > 4) return false;
        for (let j = 0; j < part.length; j++) {
          if (!isHex(part[j])) return false;
        }
        groups++;
      }
      if (compressionCount === 0 && groups !== 8) return false;
      if (compressionCount === 1 && groups >= 8) return false;
      return true;
    }

    function isValidHostnameLabel(label) {
      // RFC 1035: 1-63 chars, alnum or hyphen, cannot start or end with hyphen
      if (label.length < 1 || label.length > 63) return false;
      if (label[0] === "-" || label[label.length - 1] === "-") return false;
      for (let i = 0; i < label.length; i++) {
        const ch = label[i];
        if (ch === "-") continue;
        if (!isAlphaNum(ch)) return false;
      }
      return true;
    }

    function isValidHostname(h) {
      // prohibit trailing dot and underscores
      if (!h || h[h.length - 1] === ".") return false;
      const labels = h.split(".");
      if (labels.length < 2) return false; // require at least one dot
      for (let i = 0; i < labels.length; i++) {
        const lb = labels[i];
        if (!isValidHostnameLabel(lb)) return false;
      }
      const tld = labels[labels.length - 1];
      // TLD should be at least 2 chars and not all-numeric
      if (tld.length < 2) return false;
      if (isNumericOnly(tld)) return false;
      return true;
    }

    const isLocalhost = host === "localhost";
    const validHost =
      isLocalhost ||
      isValidIPv4(host) ||
      isValidIPv6(host) ||
      isValidHostname(host);
    if (!validHost) return false;

    return true;
  } catch {
    return false;
  }
}

// export function extractAllTestDataParameters(txtValue) {
//   const regex = /{{(.*?)}}/g;
//   const matches = [];
//   let match;
//   while ((match = regex.exec(txtValue))) {
//     matches.push(match[1]);
//   }
//   return matches;
// }

export function sanitize(html) {
  const sanitizer = dompurify.sanitize;
  if (html === null || html === undefined) {
    return "";
  }
  const processedHtml = escapeUnsupportedTags(html);
  return sanitizer(processedHtml);
}

export function normalizeKey(string) {
  return string.replace(/_/g, function (m) {
    return " ";
  });
}

export function filtersToURL(filters) {
  if (filters == undefined) return "";
  if (filters.dateFilter == undefined && filters.milestoneFilter == undefined)
    return "";

  let _filters = [];

  if (filters.dateFilter != undefined && filters.dateFilter.startDate != null)
    _filters.push(
      "start_date=" + filters.dateFilter.startDate.format("YYYY-MM-DD")
    );
  if (filters.dateFilter != undefined && filters.dateFilter.endDate != null)
    _filters.push(
      "end_date=" + filters.dateFilter.endDate.format("YYYY-MM-DD")
    );

  return "&" + _filters.join("&");
}

export const filtersToURL_New = (filters) => {
  if (filters == undefined || filters.length == 0) return "";

  let filterParam = [];
  filters.forEach((item, index) => {
    let prefix = "filters[" + index + "]";

    let serverField = item.field;
    if (item.filter.type == "user") {
      serverField = "user_id";

      filterParam.push(prefix + "[field]=" + serverField);
      filterParam.push(prefix + "[value]=" + item.filter.value.selectedOptions);
    } else {
      // needs refactoring: separate each field type
      filterParam.push(prefix + "[field]=" + serverField);
      let filterValues = item.filter.value;

      if (item.filter.type == "tag") {
        let selectedOptions = [];
        if (item.filter.value.selectedOptions) {
          item.filter.value.selectedOptions.forEach((value) => {
            //let value = item.filter.value.options.indexOf(element);
            filterParam.push(prefix + "[value][]=" + value);
          });
        }
      }

      if (item.filter.type == "option") {
        let selectedOptions = [];
        item.filter.value.selectedOptions.forEach((element) => {
          let value = item.filter.value.options.indexOf(element);
          filterParam.push(prefix + "[value][]=" + value);
        });
      } else {
        for (var key in filterValues) {
          var attrName = key;
          var attrValue = filterValues[key];
          if (key == "startDate" || key == "endDate") {
            attrValue = moment(attrValue).format("YYYY-MM-DD");
          }
          //if(typeof attrValue == 'object')
          //  attrValue = attrValue.value
          filterParam.push(prefix + "[" + key + "]=" + attrValue);
        }
      }
    }

    //let field = item.field
  });

  return "&" + filterParam.join("&");
};

export const isValidFilter = (field) => {
  if (!field.filter.value) return false;

  if (typeof field.filter.value == "object") {
    if (field.filter.type == "date") {
      if (field.filter.value.startDate && field.filter.value.endDate) {
        return true;
      }
      return false;
    }

    if (
      field.filter.type == "option" ||
      field.filter.type == "tag" ||
      field.filter.type == "user"
    ) {
      if (field.filter.value.selectedOptions) {
        return true;
      }
      return false;
    }

    if (!field.filter.value.value) return false;
  }
  return true;
};

export const registerModel = (app, model) => {
  //app.model(model.default)

  if (
    !(app._models.filter((m) => m.namespace === model.namespace).length === 1)
  ) {
    app.model(model.default);
  }
};

export const generateTree = (
  array,
  parent,
  tree = [],
  parentKey = "parentId"
) => {
  tree = tree ? tree : [];
  parent = parent ? parent : { id: 0, title: "All", parentId: 0 };
  // console.log("parent is...", parent.title);
  const children = array.filter((child) => {
    if (parent.id === 0) {
      return child.parentId == parent.id || !child.parentId;
    }
    return child.parentId == parent.id;
  });

  // console.log(`children of ${parent.title}`, children);

  if (children && children.length) {
    if (parent.id === 0) {
      tree = children;
    } else {
      parent["children"] = children;
    }

    children.map((child) => {
      generateTree(array, child);
    });
  }

  return tree;
};

export const generateCommentTree = (array, parent, tree = []) => {
  tree = tree ? tree : [];
  parent = parent ? parent : { id: 0, comment: "All", parentId: 0 };

  const children = array.filter((child) => {
    if (parent.id === 0) {
      return child.parentId == parent.id || !child.parentId;
    }
    return child.parentId == parent.id;
  });

  // console.log(`children of ${parent.comment}`, children);

  if (children && children.length) {
    if (parent.id === 0) {
      tree = children;
    } else {
      parent["children"] = children;
    }

    children.map((child) => {
      generateCommentTree(array, child);
    });
  }

  return tree;
};

export const tcFieldHelperAg = {
  // avgExecTime: time => {
  //   if (time) {
  //     time = parseInt(time);
  //     return (
  //       <span title={time + " seconds"}>
  //         {moment.duration(time, "seconds").humanize()}
  //       </span>
  //     );
  //   } else return "N/A";
  // },
  lastRanOn: (date) => {
    if (date) {
      return "<a title=''>fff</a>";
      return (
        <span title={moment(date).format("MMMM Do YYYY, h:mm:ss a")}>
          {moment(date).fromNow()}
        </span>
      );
    }
    return "N/A";
  },
};

//import moment from "moment";
export const tcFieldHelper = {
  avgExecTime: (time) => {
    if (time) {
      time = parseInt(time);
      return (
        <span title={time + " seconds"}>
          {moment.duration(time, "seconds").humanize()}
        </span>
      );
    } else return "N/A";
  },
  lastRanOn: (date) => {
    if (date) {
      return (
        <span title={moment(date).format("MMMM Do YYYY, h:mm:ss a")}>
          {moment(date).fromNow()}
        </span>
      );
    }
    return "N/A";
  },
};
export function hasFilter(filters) {
  if (filters.dateFilter.startDate != null) return true;
  if (filters.dateFilter.endDate != null) return true;

  return false;
}

export function changeUrlLocation(href) {
  //console.log("changeUrlLocation");
  //window.$.address.value(href);
  window.location.replace(href);
}

export function getUserById(store, userId) {
  const userIndex = _.keyBy(store, "id");
  if (!userIndex[userId])
    return { id: 0, name: "Not found", avatar: "notfound.png" };
  const user = userIndex[userId];
  return user;
}

export function getProjectIDfromURL() {
  var patt = /\/project\/([0-9]+)/g;
  var result = patt.exec(window.location.pathname);
  if (result && result[1]) {
    return Number(result[1]);
    //return result[1];
  }
  return 0;
}

export function getProgress(testPlan, config) {
  // const testPlan = action.payload;
  try {
    let progress = 0;
    let result = {};
    if (!testPlan) {
      return progress;
    }
    if (config && config.id) {
      if (testPlan.results && testPlan.results.configWise)
        testPlan.results.configWise.map((c) => {
          const configuration = c["configuration"];
          if (configuration.id === config.id) result = c.result;
        });
    } else {
      result = testPlan.results.overall;
    }
    let total = 0;
    for (let [key, value] of Object.entries(result)) {
      total += value;
    }
    // result.forEach(r => (total += result[r]));
    progress = ((total - result["unexecuted"]) * 100) / total;
    return Math.round(progress * 1e2) / 1e2;
  } catch (error) {
    console.log({ error });
    return 0;
  }
}
export function getMyProgress(testPlan, configs, userId) {
  // const testPlan = action.payload;
  try {
    let progress = 0;
    let result = {
      unexecuted: 0,
      passed: 0,
      skipped: 0,
      failed: 0,
      blocked: 0,
    };
    if (!testPlan) {
      return { total: progress, percents: result };
    }
    const myConfigs = [];
    configs.forEach((config) => {
      if (config && config.assignedTo && config.assignedTo.id === userId) {
        myConfigs.push(config.id);
      }
    });
    const hasConfig = myConfigs && myConfigs.length ? true : false;
    if (configs && configs.length) {
      if (testPlan.results && testPlan.results.configWise) {
        testPlan.results.configWise.map((c) => {
          const configuration = c["configuration"];
          if (myConfigs.indexOf(configuration.id) > -1 || hasConfig === false) {
            result.unexecuted +=
              c && c.result && c.result.unexecuted ? c.result.unexecuted : 0;
            result.passed +=
              c && c.result && c.result.passed ? c.result.passed : 0;
            result.skipped +=
              c && c.result && c.result.skipped ? c.result.skipped : 0;
            result.failed +=
              c && c.result && c.result.failed ? c.result.failed : 0;
            result.blocked +=
              c && c.result && c.result.blocked ? c.result.blocked : 0;
          }
        });
      }
    } else {
      result = testPlan.results.overall;
    }
    let total = 0;
    for (let [key, value] of Object.entries(result)) {
      total += value;
    }
    // result.forEach(r => (total += result[r]));
    const percents = {
      unexecuted: 0,
      passed: 0,
      skipped: 0,
      failed: 0,
      blocked: 0,
    };
    // Object.keys(result).map(r => (percents[r] = (result[r] / total) * 100));

    progress = ((total - result["unexecuted"]) * 100) / total;
    return {
      total: isNaN(progress) ? 0 : Math.round(progress * 1e2) / 1e2,
      percents: result,
    };
  } catch (error) {
    console.log({ error });
    return {
      total: 0,
      percents: { unexecuted: 0, passed: 0, skipped: 0, failed: 0, blocked: 0 },
    };
  }
}

export const renderCFValue = (customField, cfsWithId = {}) => {
  let type = "";
  if (cfsWithId && cfsWithId[customField.id]) {
    const cf = cfsWithId[customField.id] ? cfsWithId[customField.id] : {};
    type = cf["type"];
  } else {
    const split = customField.name ? customField.name.split("_") : [];
    if (split && split.length) {
      type = split[split.length - 1];
    }
  }
  switch (type) {
    case "url":
      return customField.value ? (
        <a target="_blank" href={customField.value || "#"}>
          {" "}
          {customField.valueLabel || customField.value || "NA"}
        </a>
      ) : (
        "NA"
      );
      break;
    case "date":
      return customField.value ? getLocalDate(customField.value) : "NA";
      break;

    case "user":
      return customField.value ? (
        <TCUserAvatar withName id={customField.value} />
      ) : (
        "NA"
      );
      break;
    case "number":
      return (
        <span>
          {customField.value === undefined || customField.value === null
            ? "NA"
            : customField.value}
        </span>
      );
      break;
    case "editor":
      return customField.value && customField.value.length ? (
        <div
          className="ql-editor"
          dangerouslySetInnerHTML={{
            __html: sanitize(customField.value),
          }}
        />
      ) : null;
      break;
    default:
      return <span>{customField.valueLabel || customField.value || "NA"}</span>;
      break;
  }
};

export const useQuery = (location) => {
  return new URLSearchParams(location.search);
};

export function getInitials(user) {
  let initials = "";
  if (user && user["name"]) {
    user.name
      .split(" ")
      .map((i) => (initials = initials + i.charAt(0).toUpperCase()));
  }
  return initials;
}

export const locationContains = (toMatch) =>
  window.location.pathname.indexOf(toMatch) !== -1;

export function setDocumentTitle(title) {
  document.title = title;
}

export function getBackendURL() {
  // todo: case 1: developer env
  // case 2: production env.

  //console.log(process.env)

  return window.TC_URL;
}

export function getTimezones() {
  return [
    { id: "Pacific/Tongatapu", label: "GMT+13:00) Nukualofa" },
    { id: "Pacific/Fiji", label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is." },
    { id: "Pacific/Auckland", label: "(GMT+12:00) Auckland, Wellington" },
    {
      id: "Asia/Magadan",
      label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
    },
    { id: "Asia/Vladivostok", label: "(GMT+10:00) Vladivostok" },
    { id: "Australia/Hobart", label: "(GMT+10:00) Hobart" },
    { id: "Pacific/Guam", label: "((GMT+10:00) Guam, Port Moresby" },
    {
      id: "Australia/Sydney",
      label: "(GMT+10:00) Canberra, Melbourne, Sydney, Brisbane",
    },
    { id: "Australia/Adelaide", label: "(GMT+09:30) Adelaide" },
    { id: "Asia/Yakutsk", label: "(GMT+09:00) Yakutsk " },
    { id: "Asia/Seoul", label: "(GMT+09:00) Seoul" },
    { id: "Australia/Brisbane", label: "(GMT+10:00) Brisbane" },
    { id: "Asia/Tokyo", label: "(GMT+09:00) Osaka, Sapporo, Tokyo" },
    { id: "Asia/Taipei", label: "(GMT+08:00) Taipei" },
    { id: "Australia/Perth", label: "(GMT+08:00) Perth " },
    { id: "Asia/Kuala_Lumpur", label: "(GMT+08:00) Kuala Lumpur, Singapore" },
    { id: "Asia/Irkutsk", label: "(GMT+08:00) Irkutsk, Ulaan Bataar" },
    {
      id: "Asia/Hong_Kong",
      label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi ",
    },
    { id: "Asia/Krasnoyarsk", label: "(GMT+07:00) Krasnoyarsk" },
    { id: "Asia/Bangkok", label: "(GMT+07:00) Bangkok, Hanoi, Jakarta" },
    { id: "Asia/Rangoon", label: "(GMT+06:30) Rangoon " },
    { id: "Asia/Colombo", label: "(GMT+06:00) Sri Jayawardenepura " },
    { id: "Asia/Dhaka", label: "(GMT+06:00) Astana, Dhaka" },
    { id: "Asia/Almaty", label: "(GMT+06:00) Almaty, Novosibirsk" },
    { id: "Asia/Katmandu", label: "(GMT+05:45) Kathmandu" },
    {
      id: "Asia/Calcutta",
      label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    },
    { id: "Asia/Karachi", label: "(GMT+05:00) Islamabad, Karachi, Tashkent " },
    { id: "Asia/Yekaterinburg", label: "(GMT+05:00) Ekaterinburg" },
    { id: "Asia/Kabul", label: "((GMT+04:30) Kabul" },
    { id: "Asia/Baku", label: "(GMT+04:00) Baku, Tbilisi, Yerevan" },
    { id: "Asia/Dubai", label: "(GMT+04:00) Abu Dhabi, Muscat" },
    { id: "Asia/Tehran", label: "(GMT+03:30) Tehran" },
    { id: "Africa/Nairobi", label: "(GMT+03:00) Nairobi" },
    {
      id: "Europe/Moscow",
      label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
    },
    { id: "Asia/Kuwait", label: "(GMT+03:00) Kuwait, Riyadh" },
    { id: "Asia/Baghdad", label: "(GMT+03:00) Baghdad" },
    { id: "Asia/Jerusalem", label: "(GMT+02:00) Jerusalem" },
    {
      id: "Europe/Helsinki",
      label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    },
    { id: "Africa/Harare", label: "(GMT+02:00) Harare, Pretoria" },
    { id: "Africa/Cairo", label: "(GMT+02:00) Cairo" },
    { id: "Europe/Bucharest", label: "(GMT+02:00) Bucharest" },
    { id: "Europe/Athens", label: "(GMT+02:00) Athens, Istanbul, Minsk" },
    { id: "Africa/Lagos", label: "(GMT+01:00) West Central Africa" },
    {
      id: "Europe/Warsaw",
      label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    },
    {
      id: "Europe/Brussels",
      label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
    },
    {
      id: "Europe/Belgrade",
      label: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    },
    {
      id: "Europe/Amsterdam",
      label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    },
    { id: "Africa/Casablanca", label: "(GMT) Casablanca, Monrovia" },
    {
      id: "Europe/Dublin",
      label: "(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
    },
    { id: "Atlantic/Azores", label: "(GMT-01:00) Azores" },
    { id: "Atlantic/Cape_Verde", label: "(GMT-01:00) Cape Verde Is." },
    { id: "Atlantic/South_Georgia", label: "(GMT-02:00) Mid-Atlantic" },
    { id: "America/Sao_Paulo", label: "(GMT-03:00) Brasilia" },
    {
      id: "America/Buenos_Aires",
      label: "(GMT-03:00) Buenos Aires, Georgetown",
    },
    { id: "America/Thule", label: "(GMT-03:00) Greenland" },
    { id: "America/St_Johns", label: "(GMT-03:30) Newfoundland" },
    { id: "America/Montreal", label: "(GMT-04:00) Atlantic Time (Canada)" },
    { id: "America/Caracas", label: "(GMT-04:00) Caracas, La Paz" },
    { id: "America/Santiago", label: "(GMT-04:00) Santiago" },
    { id: "America/Bogota", label: "(GMT-05:00) Bogota, Lima, Quito" },
    { id: "America/New_York", label: "(GMT-05:00) Eastern Time (US & Canada)" },
    { id: "America/Indianapolis", label: "(GMT-05:00) Indiana East" },
    { id: "America/Costa_Rica", label: "(GMT-06:00) Central America" },
    { id: "America/Chicago", label: "(GMT-06:00) Central Time (US & Canada)" },
    {
      id: "America/Mexico_City",
      label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
    },
    { id: "America/Winnipeg", label: "(GMT-06:00) Saskatchewan" },
    { id: "America/Phoenix", label: "(GMT-07:00) Arizona" },
    {
      id: "America/Tegucigalpa",
      label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
    },
    { id: "America/Denver", label: "(GMT-07:00) Mountain Time (US & Canada)" },
    {
      id: "America/Los_Angeles",
      label: "(GMT-08:00) Pacific Time (US & Canada) Tijuana",
    },
    { id: "America/Anchorage", label: "(GMT-09:00) Alaska" },
    { id: "Pacific/Honolulu", label: "(GMT-10:00) Hawaii" },
    { id: "Pacific/Apia", label: "(GMT-11:00) Midway Island, Samoa" },
  ];
}

export const getCustomFieldTypes = () => [
  "text",
  "dropdown",
  "multipleSelect",
  "textarea",
  "date",
  "number",
  "url",
  "user",
  "editor",
];

export const getUserAvatarURL = (avatar, avatarObj) => {
  if (avatarObj) {
    if (avatarObj.provider && avatarObj.provider !== "local") {
      return avatarObj.url;
    }
  }
  if (avatar == null) {
    return undefined;
  }

  if (!avatar) {
    return undefined;
  }

  let location = getLocationForCurrentSession();
  if (location == "EU") {
    return TC_MEDIA_URL_EU + "uploads/" + avatar;
  }

  return window.TC_MEDIA_URL + "uploads/" + avatar;
};

export const getMaxIndex = (options) => {
  let max = 0;
  if (Array.isArray(options) && options.length) {
    options.forEach(
      (o) =>
        (max =
          o.systemValue && o.systemValue > max ? (max = o.systemValue) : max)
    );
  }

  return max + 1;
};

export const getAPIKey = () => {
  return window.API_KEY;
};

export const getSessionUser = () => {
  return sessionUser;
};

export const getAttachmentViewPageUrl = (companyId, attachment) => {
  if (companyId && attachment && attachment["id"]) {
    let newSlug = CryptoJS.AES.encrypt(
      `company-${companyId}-attachment-${attachment["id"]}`,
      process.env.SECRET_KEY_FOR_TOKEN
    ).toString();
    newSlug = escape(newSlug);
    return `${process.env.BASE_URL}/attachment_view/${newSlug}`;
  }
  return "";
};

export const parseAttachmentSlug = (cipherText) => {
  cipherText = unescape(cipherText);
  while (cipherText.indexOf(" ") > 0) {
    cipherText = cipherText.replace(" ", "+");
  }
  let bytes = CryptoJS.AES.decrypt(
    cipherText,
    process.env.SECRET_KEY_FOR_TOKEN
  );
  let originalText = bytes.toString(CryptoJS.enc.Utf8);
  let newArr = originalText.split("-");
  if (newArr && Array.isArray(newArr) && newArr.length == 4) {
    return { companyId: newArr[1], attachmentId: newArr[3] };
  }
  return null;
};

export const downloadLink = (attachment, company = null) => {
  if (attachment && attachment.url) {
    if (attachment.url.startsWith("http")) {
      return attachment.url;
    }
    if (attachment.hash && attachment.ext) {
      if (process.env.TC_REGION === "EU") {
        return `${window.TC_MEDIA_URL_EU}attachments/${attachment.hash}${attachment.ext}`;
      }
      return `${window.TC_MEDIA_URL}/attachments/${attachment.hash}${attachment.ext}`;
    }
  }
  if (typeof attachment === "string" && attachment.startsWith("http")) {
    if (attachment.startsWith("http")) {
      return attachment;
    }
    if (process.env.TC_REGION === "EU") {
      return `${window.TC_MEDIA_URL_EU}attachments/${attachment
        .split("/")
        .pop()}`;
    }
    return `${window.TC_MEDIA_URL}attachments/${attachment.split("/").pop()}`;
  }
  let queryStr = "";
  let attachmentUrl = "";
  if (company && company.id) {
    let token = "0";
    let attachmentsPrivate = isPrivateAttachments(company);
    if (attachmentsPrivate) {
      //token = `${company.id}${window["JWT"]}${company.id}`;
      token = getEncryptedToken();
      token = escape(token);
    }
    queryStr = `?company=${company.id}&tk=${token}`;
  }
  if (attachment.provider && attachment.provider !== "local")
    return attachment.url;

  if (attachment.hash != undefined) {
    attachmentUrl = `${attachment.hash}${attachment.ext}`;
  }
  if (typeof attachment === "string") {
    if (attachment.startsWith("https://")) {
      return attachment;
    }
    if (attachment.includes("s3.amazonaws.com")) {
      // @tc-debt Temp hack for s3 URL
      return attachment;
    }

    attachmentUrl = attachment.substr(
      attachment.lastIndexOf("uploads/") + 8,
      attachment.indexOf("?company=") - attachment.lastIndexOf("uploads/") - 8
    );
  }
  let location = getLocationForCurrentSession();
  if (location == "EU") {
    return TC_MEDIA_URL_EU + "uploads/" + attachmentUrl + queryStr;
  }
  return TC_MEDIA_URL + "uploads/" + attachmentUrl + queryStr;
};

export const getEncryptedToken = (tokenStr = null) => {
  return CryptoJS.AES.encrypt(
    tokenStr && tokenStr.length ? tokenStr : window["JWT"],
    process.env.SECRET_KEY_FOR_TOKEN
  ).toString();
};

export const formatNmae = (fullName) => {
  // Get first and last name
  const names = _.words(fullName);
  return `${_.capitalize(_.head(names))} ${_.capitalize(_.last(names))}`;
};

// TCV-6854: company-wide "Opt out of AI features" switch (Settings > General).
// When it is on, every AI surface is hidden for every user in the account and
// any project-level AI setting is ignored.
export const AI_OPTOUT_SETTING_NAME = "ai_optout_enabled";

export const isAiOptedOut = (company) => {
  const setting = _.find(_.get(company, "settings", []), {
    name: AI_OPTOUT_SETTING_NAME,
  });
  const value = _.get(setting, "value");
  return value === 1 || value === "1" || value === true || value === "true";
};

// TCV-6564: avatar display format utilities
export const AVATAR_DISPLAY_FORMATS = {
  INITIALS: "initials",
  FULL_NAME: "full_name",
  F_LASTNAME: "f_lastname",
  FIRSTNAME_L: "firstname_l",
};

export const getAvatarDisplayFormat = (company) => {
  if (company && company.settings) {
    const setting = company.settings.find(
      (s) => s && s.name === "avatar_display_format"
    );
    if (setting && setting.value) {
      return setting.value;
    }
  }
  return AVATAR_DISPLAY_FORMATS.INITIALS;
};

export const formatAvatarDisplayName = (fullName, format) => {
  if (!fullName) return "";
  const names = _.words(fullName);
  if (names.length === 0) return "";
  const firstName = _.capitalize(_.head(names));
  const lastName = names.length > 1 ? _.capitalize(_.last(names)) : "";
  switch (format) {
    case AVATAR_DISPLAY_FORMATS.FULL_NAME:
      return lastName ? `${firstName} ${lastName}` : firstName;
    case AVATAR_DISPLAY_FORMATS.F_LASTNAME:
      return lastName ? `${firstName.charAt(0)}. ${lastName}` : firstName;
    case AVATAR_DISPLAY_FORMATS.FIRSTNAME_L:
      return lastName ? `${firstName} ${lastName.charAt(0)}.` : firstName;
    default:
      return "";
  }
};

const normalizeCustomFieldName = (value = "") =>
  value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

export const isExactAssigneeCustomField = (field = {}) => {
  const normalizedName = normalizeCustomFieldName(field.name || "");
  const normalizedLabel = normalizeCustomFieldName(field.label || "");
  const exactMatches = ["assignee", "assigned_to"];

  return (
    exactMatches.includes(normalizedName) ||
    exactMatches.includes(normalizedLabel)
  );
};

export const isAssigneeCustomField = (field = {}) => {
  if (isExactAssigneeCustomField(field)) {
    return true;
  }

  const fieldText = `${field.name || ""} ${field.label || ""}`;
  return /\bassignee\b|\bassigned[_\s-]?to\b/i.test(fieldText);
};

export const getDecryptedToken = (cipherText) => {
  var bytes = CryptoJS.AES.decrypt(
    cipherText,
    process.env.SECRET_KEY_FOR_TOKEN
  );
  var originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};

export const isPrivateAttachments = (company) => {
  if (company && company.id) {
    let compSetting =
      company.settings != undefined
        ? company.settings.find(
            (csettings) => csettings && csettings.name == "attachments_private"
          )
        : null;
    if (compSetting && compSetting.value === "0") {
      return false;
    }
  }
  return true;
};

export const handleError = async (status, messages = {}, message = null) => {
  const defaultMsg = {
    401: ["Unauthorized", "You are not authorized!"],
    400: ["Bad request", "Request data is not correct!"],
    403: [
      "Forbidden",
      "Check with your administrator if you have the right to perform this operation?",
    ],
    422: ["Bad data", "Data provided is invalid."],
    404: ["Not found", "Record not found!"],
    406: ["Not acceptable", "Data not acceptable!"],
    500: [
      "Server error",
      "An error occurred on server, please try this again. If problem persists, please contact us.",
    ],
  };
  let _messages = { ...defaultMsg, messages };
  if (_messages[status] == undefined && message && message.length) {
    _messages[status] = [message, message];
  }
  if (_messages[status]) {
    notification["error"]({
      message: _messages[status][0],
      description: message || _messages[status][1],
      duration: 7,
    });
  } else {
    console.error("Unknown error occurred!  Status code: " + status);
  }
};

export const hasIssueManagerLinked = (projectSettingsByKey) => {
  let imName = _.get(projectSettingsByKey, "issue_manager.value", null);
  let imSetting = _.get(
    projectSettingsByKey,
    "issue_manager_setting.value",
    null
  );
  if (!imName || !imSetting) {
    if (imName && imName == "inbuilt") {
      return true;
    }
    return false;
  }
  return true;
};
export const getEmailRegex = () => {
  return new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};
export const saveFilter = (params) => {};

export const getRoleOptions = () => {
  return {
    tester: "Tester or Test Analyst",
    team_leader: "QA Lead or Manager",
    team_member: "QA or IT Director",
    manager: "Project Manager",
    // vp: "VP",
    // consultant: "Consultant",
    // contractor: "Contractor",
    consultant_contractor: "Consultant or Contractor",
    director: "C level officer/ CEO",
    student: "Student",
    other: "Other",
  };
};

export const getManageOptions = () => {
  return {
    business: "Business and Information",
    edu: "Education",
    finance: "Finance and Insurance",
    tech: "Internet/Technology",
    gaming: "Gaming",
    govt: "Government",
    health: "Healthcare",
    personal: "Personal Services",
    marketing: "Marketing",
    retail: "Retail",
    transporation: "Transporation",
    security: "Security and Legal",
    other: "Other Industry",
  };
};

export const getUnescapedString = (str, removeAllTags = true) => {
  if (!str || !str.length) {
    return str;
  }
  try {
    str = unescape(str);
  } catch (e) {
    console.log({ decode_err: e, str });
    str = unescape(str.replace("%u201C", '"'));
  }
  str = str
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'");
  if (removeAllTags) {
    str = striptags(str);
  }
  return str;
};

export const stripNotAllowedTags = (str, allowedTags) => {
  if (typeof str == "string") {
    if (!str || !str.length) {
      return str;
    }
    try {
      if (allowedTags) {
        str = striptags(str, allowedTags);
      }
    } catch (e) {
      console.log({ strip_tags_err: e, str, allowedTags });
    }
  }
  return str;
};

export const convertHtmlToMarkdown = (html) => {
  if (html && html.trim().length) {
    return turndownService.turndown(html).trim();
  }
  return html;
};

export const fixMarkDownImages = (markdown) => {
  if (markdown && markdown.trim().length) {
    // Regular expression to match markdown image links
    const imageLinkRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;

    // Replace image links with simple links
    return markdown.replace(imageLinkRegex, (match, altText, url) => {
      return `[${url}](${url})`; // Replace image link with the URL as a link
    });
  }
  return markdown;
};

// /**
//  * Fixes Markdown rendering issues:
//  * 1) Escapes stray trailing pipes so they don't extend/break tables.
//  * 2) Normalizes Markdown image URLs by encoding unsafe characters and
//  *    removing optional surrounding angle brackets.
//  */
// export const fixMarkDownImages = (markdown) => {
//   if (typeof markdown !== "string" || !markdown.length) return markdown;
//   try {
//     let output = markdown.replace(/\r\n/g, "\n");

//     // Escape solitary trailing pipes at EOL to avoid accidental table continuation
//     output = output.replace(/^(.*)\|[ \t]*$/gm, (line) => {
//       const pipeCount = (line.match(/\|/g) || []).length;
//       if (line.trim().startsWith("|")) return line; // legit table row
//       if (pipeCount > 1) return line; // probably a table row
//       return line.replace(/\|[ \t]*$/, "\\|");
//     });

//     // Normalize image URLs in Markdown: ![alt](url "title")
//     output = output.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (match, alt, urlPart) => {
//       let url = urlPart.trim();
//       let title = "";

//       // Extract optional title ("..." or '...') after URL
//       const titled = url.match(/^(<[^>]+>|[^)\s]+)\s+("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')\s*$/);
//       if (titled) {
//         url = titled[1];
//         title = " " + titled[2];
//       }
//       if (url.startsWith("<") && url.endsWith(">")) {
//         url = url.slice(1, -1);
//       }
//       let safe = url;
//       try {
//         safe = encodeURI(url); // encodes spaces and other unsafe chars, keeps URL structure
//       } catch (e) {
//         safe = url;
//       }
//       return `![${alt}](${safe}${title})`;
//     });

//     return output;
//   } catch (e) {
//     console.log({ fix_markdown_images_error: e });
//   }
//   return markdown;
// };

// export const convertStepAttachmentToLink = (str, isHtml = true) => {
//   if (typeof str == "string") {
//     if (!str || !str.length) {
//       return str;
//     }
//     try {
//       let splitStrBase = '<div class="attachment"><div data-attr="{&quot;link&quot;:&quot;';
//       // let splitStrBase = '<div class="attachment"><div data-attr="{&quot;link&quot;:&quot;';
//       if (str.split(splitStrBase).length > 1) {
//         let strArr = str.split(splitStrBase);
//         let newStr = strArr.map((strItem, indx) => {
//           if (indx == 0) {
//             return strItem;
//           }
//           let strItemArr = strItem.split('</div></div>');
//           let strToProcess = strItemArr.shift();
//           strItem = strItemArr.length > 1 ? strItemArr.join('</div></div>') : strItemArr.join("");
//           let rexImg = /<img[^>]*>/g;
//           let rexImgSrc = /src="(https:\/\/[^">]+)"/g;
//           let imgList = [];
//           let tgVal = null;
//           let tgSrcVal = null;
//           while (tgVal = rexImg.exec(strToProcess)) {
//             if (tgVal && tgVal.length) {
//               tgSrcVal = rexImgSrc.exec(tgVal[0]);
//               if (tgSrcVal && tgSrcVal.length) {
//                 imgList.push({ tagStr: tgVal[0], srcValue: tgSrcVal[1] });
//               }
//             }
//           }
//           let convertedData = "";
//           if (imgList.length) {
//             imgList.forEach((itm, indx) => {
//               convertedData = `<a href="${itm.srcValue}">Attachment ${indx + 1}</a>`;
//               // if not html then convert to markdown link
//               if (!isHtml) {

//               }
//             });
//           }
//           return `${convertedData}${strItem}`;
//         }).join("");
//         str = newStr;
//       }
//     } catch (e) {
//       console.log({ convertStepAttachmentToLink_err: e, str });
//     }
//   }
//   return str;
// }

export const getAsanaAllowedTags = () => {
  return [
    "body",
    "strong",
    "em",
    "u",
    "s",
    "code",
    "ol",
    "ul",
    "li",
    "a",
    "h1",
    "h2",
    "hr",
    "img",
    "table",
    "tr",
    "td",
  ];
};

export const activityTypeLabels = {
  add: "Add",
  archive: "Archive",
  assignee_change: "Assignee changed",
  bulkarchive: "Bulk Archive",
  bulkcopy: "Bulk Copy",
  bulkdelete: "Bulk Delete",
  bulkedit: "Bulk Edit",
  bulkreopen: "Bulk Reopen",
  // bulkupdate: "Bulk Update",
  changesuperadmin: "Change Super Admin",
  comment: "Comment",
  copy: "Copy",
  // create: "Add",
  delete: "Delete",
  edit: "Edit",
  export: "Export",
  forgotpassword: "Forgot Password",
  import: "Import",
  invite: "Invite",
  link: "Link",
  login_failed: "Login failed",
  login: "Login",
  logout: "Logout",
  movetotrash: "Move to Trash",
  passwordchanged: "Password Changed",
  rankdowngrade: "Rank downgraded",
  rankupgrade: "Rank upgraded",
  reopen: "Reopen",
  restore: "Restore",
  resetallpasswords: "Reset All Passwords",
  resetpassword: "Reset Password",
  run: "Run",
  status_change: "Status changed",
  testcase_status_change: "Test case status changed",
  // unarchive: "Reopen",
  unlink: "Unlink",
  review_reject_revert: "Reject and Revert",
  review_reject: "Reject and Remove",
  review_approved: "Test Case Approved",
  // TCV-6631: lets the audit log filter on the "Change reviewer" action.
  review_reassigned: "Change Reviewer",
  // update: "Update",
};

export const entityTypeLabels = {
  company: "Company",
  customfield: "Custom Field",
  defect: "Defect",
  // executedtestcase: "Test Plan's Case",
  issuemanagerprofile: "Defect Profile Settings",
  issuemanagersetting: "Defect Settings",
  project: "Project",
  projectuser: "Project Member",
  requirementprofile: "Requirement Profile Settings",
  requirementsetting: "Requirement Settings",
  reusablestep: "Reusable Step",
  role: "Role",
  setting: "Setting",
  suite: "Suite",
  tag: "Tag",
  // tcrole: "Role",
  testcase: "Test Case",
  // testplantestcase: "Test Plan's Case",
  testplanfolder: "Test Plan Folder",
  testplan: "Test Plan",
  testplanrun: "Test Plan Run",
  user: "User",
  issue: "Issue",
  // TCV-6655: Risk-Based Testing entities (activity feed + audit log filters).
  risk: "Risk",
  risksetting: "Risk Settings",
  riskscalevalue: "Risk Scale",
  riskstatus: "Risk Status",
  risktype: "Risk Type",
};

export const showFilterAppliedLabel = (gridApi) => {
  if (gridApi != undefined && gridApi) {
    let filters = gridApi.getFilterModel();
    if (filters && Object.keys(filters).length) {
      var cols = gridApi.columnController.columnDefs;
      let filterTooltip = [];
      let addedFields = new Set(); // Track added fields to prevent duplicates

      Object.keys(filters).forEach((item) => {
        if (
          (filters[item].filterType != "date" &&
            (filters[item].filter == undefined ||
              filters[item].filter == null ||
              filters[item].filter == "")) ||
          (filters[item].filterType == "date" &&
            (filters[item].dateFrom == undefined ||
              filters[item].dateFrom == null ||
              filters[item].dateFrom == "")) ||
          item == "advancedFilters"
        ) {
          if (item == "advancedFilters") {
            let filterData = filters[item];
            if (
              filterData &&
              filterData.filter &&
              typeof filterData.filter == "string"
            ) {
              filterData = JSON.parse(filterData.filter);
            }
            if (filterData && filterData.jsonTree && filterData.simpleFilters) {
              if (Object.keys(filterData.simpleFilters).length) {
                Object.keys(filterData.simpleFilters).forEach((filterField) => {
                  let colData = cols.find(
                    (cc) => cc && cc.field == filterField
                  );
                  let fieldName =
                    colData && colData.headerName
                      ? colData.headerName
                      : _.capitalize(filterField);

                  // Only add if not already added
                  if (!addedFields.has(fieldName)) {
                    filterTooltip.push(fieldName);
                    addedFields.add(fieldName);
                  }
                });
              }
            }
          }
          //not a valid filter
        } else {
          let colData = cols.find((cc) => cc && cc.field == item);
          let fieldName =
            colData && colData.headerName
              ? colData.headerName
              : _.capitalize(item);

          // Only add if not already added
          if (!addedFields.has(fieldName)) {
            filterTooltip.push(fieldName);
            addedFields.add(fieldName);
          }
        }
      });
      if (filterTooltip.length) {
        const uniqueFields = Array.from(addedFields);
        return (
          <span>
            <Tooltip title={`Filter applied on - ${uniqueFields.join(", ")}`}>
              {" "}
              <Icon
                type="filter"
                className="tc_filter_info"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (gridApi) {
                    const opened =
                      gridApi.getOpenedToolPanel &&
                      gridApi.getOpenedToolPanel();
                    if (opened === "custom_filter") {
                      // Only close the filter panel, don't hide the entire sidebar
                      if (gridApi.closeToolPanel) gridApi.closeToolPanel();
                    } else {
                      // Show sidebar and open filter panel
                      if (gridApi.setSideBarVisible)
                        gridApi.setSideBarVisible(true);
                      if (gridApi.openToolPanel)
                        gridApi.openToolPanel("custom_filter");
                    }
                  }
                }}
              />
            </Tooltip>
          </span>
        );
      }
    }
  }
  return null;
};

export const getSuitePathArray = (suiteId, childs, sPath = []) => {
  if (childs && childs.length) {
    childs.forEach((child) => {
      if (child && child["id"] && child["id"] == suiteId) {
        sPath.push(child);
      } else {
        if (!sPath.length) {
          if (child["children"] && child["children"].length) {
            sPath = getSuitePathArray(suiteId, child["children"], sPath);
            if (sPath.length) {
              sPath.push(child);
            }
          }
        }
      }
    });
  }
  return sPath;
};

export const getSuitePathString = (suiteId, childs, sPath = []) => {
  let suitePath = getSuitePathArray(suiteId, childs, sPath);
  if (suitePath && suitePath.length) {
    if (suitePath.length == 1) {
      return suitePath.pop()["title"];
    }
    let sPath = "";
    while (suitePath.length) {
      sPath = `${sPath}${sPath.length ? " >> " : ""}${
        suitePath.pop()["title"]
      }`;
    }
    return sPath;
  }
};

export const printAction = (docTitle = null, divId = null) => {};

export const getIssueManagerName = (issueManager) => {
  if (issueManager == "jira") {
    return "Jira Software Cloud";
  }
  if (issueManager == "pivotaltracker") {
    return "Pivotal Tracker";
  }
  if (issueManager == "azuredevops") {
    return "Azure DevOps (Legacy)";
  }
  // TCV-6724 Entra-based connect option (persisted as an "azuredevops" connection).
  if (issueManager == "azuredevopsentra") {
    return "Azure DevOps";
  }
  if (issueManager == "clickup") {
    return "ClickUp";
  }
  if (issueManager == "servicenow") {
    return "ServiceNow";
  }
  return _.capitalize(issueManager);
};

// TCV-6724 Azure DevOps has two connect options that share the same backend connection
// (persisted as "azuredevops"): the classic OAuth app and the Entra ID app. Treat both keys
// as Azure DevOps in behavior checks.
export const isAzureDevOps = (issueManager) =>
  issueManager === "azuredevops" || issueManager === "azuredevopsentra";

export const toStoredIssueManager = (issueManager) =>
  issueManager === "azuredevopsentra" ? "azuredevops" : issueManager;

// TCV-6724 A connection linked via the Entra option is stored as "azuredevops" with
// configuration.oauth_provider === "entra" (carried in the issue_manager_setting value).
// Resolve it back to the distinct "azuredevopsentra" key for display, so labels and the
// selected option card reflect how the connection was actually linked.
export const resolveDisplayIssueManager = (
  managerValue,
  issueManagerSettingValue
) => {
  if (managerValue !== "azuredevops" || !issueManagerSettingValue) {
    return managerValue;
  }
  try {
    const conf =
      typeof issueManagerSettingValue === "string"
        ? JSON.parse(issueManagerSettingValue)
        : issueManagerSettingValue;
    if (conf && conf.oauth_provider === "entra") {
      return "azuredevopsentra";
    }
  } catch (e) {
    // malformed setting — fall back to the raw value
  }
  return managerValue;
};

export const defectDefaultFieldOptions = {
  priority: [
    { id: 1, label: "Lowest" },
    { id: 2, label: "Low" },
    { id: 3, label: "Normal" },
    { id: 4, label: "High" },
    { id: 5, label: "Critical" },
  ],
  status: [
    { id: 1, label: "To Do" },
    { id: 2, label: "In Progress" },
    { id: 3, label: "In Review" },
    { id: 4, label: "Done" },
    { id: 5, label: "Re Opened" },
    { id: 6, label: "Closed" },
  ],
};

export const getIssuePriorityFieldOptions = (projectSettingsByKey) => {
  try {
    let fieldOptions = JSON.parse(
      _.get(projectSettingsByKey, "defect_field_options.value", "{}")
    );
    if (
      fieldOptions &&
      Object.keys(fieldOptions) &&
      Object.keys(fieldOptions).length
    ) {
      // use modified
    } else {
      fieldOptions = defectDefaultFieldOptions;
    }
    return fieldOptions["priority"];
  } catch (e) {
    return defectDefaultFieldOptions["priority"];
  }
};

export const getIssueStatusFieldOptions = (projectSettingsByKey) => {
  try {
    let fieldOptions = JSON.parse(
      _.get(projectSettingsByKey, "defect_field_options.value", "{}")
    );
    if (
      fieldOptions &&
      Object.keys(fieldOptions) &&
      Object.keys(fieldOptions).length
    ) {
      // use modified
    } else {
      fieldOptions = defectDefaultFieldOptions;
    }
    return fieldOptions["status"];
  } catch (e) {
    return defectDefaultFieldOptions["status"];
  }
};

export const isReviewEnabled = (settings, planDetails) => {
  const isApprovalFeatureEnabled = _.get(
    _.find(_.get(planDetails, "features", []), { name: "testCaseApproval" }),
    "allowed"
  );
  if (isApprovalFeatureEnabled) {
    if (
      settings &&
      settings["review_enabled"] &&
      settings["review_enabled"]["value"] &&
      settings["review_enabled"]["value"] == "1"
    ) {
      return true;
    }
    // if (settings && settings.id) {
    //   if (settings.settings && settings.settings.length) {
    //     let reviewEnabled = settings.settings.find(
    //       r => r && r.name && r.name == "review_enabled"
    //     );
    //     if (
    //       reviewEnabled &&
    //       reviewEnabled.value &&
    //       reviewEnabled.value.toString() == "1"
    //     ) {
    //       return true;
    //     }
    //   }
    // }
  }
  return false;
};

export const isReviewMandatory = (settings, planDetails) => {
  const isApprovalFeatureEnabled = _.get(
    _.find(_.get(planDetails, "features", []), { name: "testCaseApproval" }),
    "allowed"
  );
  if (isApprovalFeatureEnabled) {
    if (
      settings &&
      settings["review_enabled"] &&
      settings["review_enabled"]["value"] &&
      settings["review_enabled"]["value"] == "1"
    ) {
      if (
        settings &&
        settings["review_mandatory"] &&
        settings["review_mandatory"]["value"] &&
        settings["review_mandatory"]["value"] == "1"
      ) {
        return true;
      }
    }
    // if (settings && settings.id) {
    //   if (settings.settings && settings.settings.length) {
    //     let reviewEnabled = settings.settings.find(
    //       r => r && r.name && r.name == "review_enabled"
    //     );
    //     if (
    //       reviewEnabled &&
    //       reviewEnabled.value &&
    //       reviewEnabled.value.toString() == "1"
    //     ) {
    //       let reviewMandatory = settings.settings.find(
    //         r => r && r.name && r.name == "review_mandatory"
    //       );
    //       if (
    //         reviewMandatory &&
    //         reviewMandatory.value &&
    //         reviewMandatory.value.toString() == "1"
    //       ) {
    //         return true;
    //       }
    //     }
    //   }
    // }
  }
  return false;
};

export const isAdminUser = (userData) => {
  if (
    userData &&
    userData.id &&
    userData.rank &&
    userData.rank.toLowerCase() == "administrator"
  ) {
    return true;
  }
  return false;
};

export const isCompanyOwner = (userData, companyData) => {
  if (
    userData &&
    userData.id &&
    companyData &&
    companyData.id &&
    companyData.owner
  ) {
    if (companyData.owner.id && companyData.owner.id == userData.id) {
      return true;
    }
    if (companyData.owner && companyData.owner == userData.id) {
      return true;
    }
  }
  return false;
};

// export const appendCopilotIfEnabled = (
//   planDetails,
//   projectSettingsByKey,
//   membersData
// ) => {
//   let isCopilotEnabled = false;
//   const hasAutomationEnabled = _.get(
//     _.find(_.get(planDetails, "features", []), { name: "qaCopilot" }),
//     "allowed"
//   );
//   if (hasAutomationEnabled) {
//     let tmpValue = _.get(projectSettingsByKey, "enable_copilot.value", null);
//     if (tmpValue == "1" || tmpValue == 1) {
//       isCopilotEnabled = true;
//     }
//   }

//   if (isCopilotEnabled) {
//     let projectData = {};
//     let roleData = {};
//     if (membersData && membersData.length) {
//       if (membersData[0].project && membersData[0].project.id) {
//         projectData = membersData[0].project;
//       }
//       if (membersData[0].role && membersData[0].role.id) {
//         roleData = membersData[0].role;
//       }
//       membersData.push({
//         id: -1,
//         project: projectData,
//         role: roleData,
//         user: {
//           id: -1,
//           name: "Co-pilot",
//           email: "copilot@testcollab.io",
//           username: "Co-pilot",
//           confirmed: true,
//           rank: "User",
//           createdAt: moment().format("YYYY-MM-DDThh:mm:ss.000Z")
//         },
//         createdAt: moment().format("YYYY-MM-DDThh:mm:ss.000Z"),
//         updatedAt: moment().format("YYYY-MM-DDThh:mm:ss.000Z")
//       });
//     }
//   }
//   return membersData;
// };

export const replaceImgWithLink = (str, isHtml = true) => {
  try {
    if (typeof str == "string") {
      if (str && str.length) {
        let rexImg = /<img[^>]*>/g;
        let rexImgSrc = /src="(https:\/\/[^">]+)"/g;
        let imgList = [];
        let tgVal = null;
        let tgSrcVal = null;
        while ((tgVal = rexImg.exec(str))) {
          if (tgVal && tgVal.length) {
            tgSrcVal = rexImgSrc.exec(tgVal[0]);
            if (tgSrcVal && tgSrcVal.length) {
              imgList.push({ tagStr: tgVal[0], srcValue: tgSrcVal[1] });
            }
          }
        }
        if (imgList.length) {
          imgList.forEach((itm, indx) => {
            let linkValue = ` <a href="${itm.srcValue}">Attachment ${
              indx + 1
            }</a> `;
            // if not html then convert to markdown link
            if (!isHtml) {
            }
            str = str.split(itm.tagStr).join(linkValue);
          });
        }
      }
    }
  } catch (e) {
    console.log({ replaceImgWithLink_error: e });
  }
  return str;
};

// export const getFeatureStatus = featureName => {
//   let strData = localStorage.getItem(`feature-${featureName}`);
//   if (strData == "1") {
//     return { enabled: true };
//   }
//   return { enabled: false };
// };

export const nl2br = (str) => {
  if (!str || !str.length) {
    return str;
  }
  try {
    return (str + "").replace(
      /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
      "$1" + "<br />" + "$2"
    );
  } catch (e) {
    console.log({ nl2br_err: e });
  }
  return str;
};

export const getValidatorStatuses = () => {
  return {
    0: { label: "Awaiting test", color: "gray", icon: "clock-circle" },
    1: {
      label: "Pending",
      color: "rgba(153,153,153,1)",
      icon: "info-circle",
    },
    2: { label: "Approved", color: "rgb(85, 167, 65)", icon: "check-circle" },
    3: { label: "Rejected", color: "rgb(183, 58, 58)", icon: "close-circle" },
  };
};

export const toggleShowMore = (text, limit = 100) => {
  if (text && text.length > 0) {
    text = text.split("\n").join(" ").trim(); // Remove new lines and trim spaces
    if (text.length == 0) {
      return null; // Return null if text is empty after processing
    }
    if (text.length > limit) {
      let randNum = Math.random().toString(36).substring(7);
      return (
        <span>
          <span className={`see-more trim-text-${randNum}`}>
            {text.slice(0, limit)}...
            <a
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector(`.trim-text-${randNum}`)
                  .classList.add("d-none");
                document
                  .querySelector(`.full-text-${randNum}`)
                  .classList.remove("d-none");
              }}
            >
              See more
            </a>
          </span>
          <span className={`see-less full-text-${randNum} d-none`}>
            {text}{" "}
            <a
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector(`.trim-text-${randNum}`)
                  .classList.remove("d-none");
                document
                  .querySelector(`.full-text-${randNum}`)
                  .classList.add("d-none");
              }}
            >
              See less
            </a>
          </span>
        </span>
      );
    } else {
      return <span>{text}</span>;
    }
  }
  return null;
};
